// extracted by css-extract-rspack-plugin
export default {"multiselect":"multiselect-Q2WGca"};